/**
 * Spine (kernel-native: the kernel is the system of record; no coreBOS module yet).
 * Categories of personal data (kind: common | special (GDPR Art. 9) | judicial (Art. 10)). Home of the GDPR meaning PersonalDataCategories lost.
 * Hand-written (ADR-029 §4); links to other spines are graph edges, see src/spines.ts.
 */
export const dataCategoryDescriptor = {
    slug: 'cmp_data_category',
    kind: 'document',
    label: { singular: 'Categoria di dati', plural: 'Categorie di dati' },
    table: 'compliance_data_category',
    idStrategy: 'sha256',
    fields: [
        { name: 'name', type: 'text', label: 'Nome', required: true },
        { name: 'kind', type: 'text', label: 'Tipo' },
        { name: 'description', type: 'text', label: 'Descrizione' },
    ],
    relations: [],
    behaviors: { audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'TagsOutlined', navGroup: 'Organizzazione' },
};
